import React from "react";
import {injectIntl, InjectedIntlProps} from 'react-intl';

import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import { alpha } from '@material-ui/core/styles'

import UseFilterKey from "../../../Utils/UseFilterKey";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    search: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: alpha(theme.palette.common.white, 0.15),
      '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
      },
      marginRight: 0,
      marginLeft: theme.spacing(1),
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        width: 'auto',
        marginRight: theme.spacing(1),
      },
    },
    searchIcon: {
      width: theme.spacing(7),
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    inputRoot: {
      color: 'inherit',
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 7),
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: 200,
      },
    },
  }),
);

export type UseFilterKeySearchBarProps = InjectedIntlProps;

const UseFilterKeySearchBar = (props: UseFilterKeySearchBarProps) => {
  const classes = useStyles();
  const { intl } = props;
  return (
    <div className={classes.search}>
      <div className={classes.searchIcon}>
        <SearchIcon />
      </div>
      <UseFilterKey
        render={(x: any) => {
          return (
            <form noValidate autoComplete="off" onSubmit={x.handleFilterSubmit}>
              <InputBase
                id="search"
                type="search"
                placeholder={intl.formatMessage({id: 'searchBar.placeholder'})}
                value={x.filterInput}
                onChange={x.handleFilterChange}
                classes={{
                  root: classes.inputRoot,
                  input: classes.inputInput,
                }}
                inputProps={{'aria-label': 'search'}}
              />
            </form>
          );
        }}
      />
    </div>
  );
};

export default injectIntl(UseFilterKeySearchBar);
